<script setup lang="ts">
import { computed } from 'vue'
import { useTheme } from 'vuetify'

import { BlockOnlineMusicAndVideoColors } from '@kidzonet/consts/src/PolicyColors'

import IconWrapper from './BaseIcon.vue'

const theme = useTheme()

const iconColor = computed(
    () => theme.global.current.value.dark
        ? BlockOnlineMusicAndVideoColors.icon.dark
        : BlockOnlineMusicAndVideoColors.icon.light,
)
const backgroundColor = computed(
    () => theme.global.current.value.dark
        ? BlockOnlineMusicAndVideoColors.background.dark
        : BlockOnlineMusicAndVideoColors.background.light,
)
</script>

<template>
    <IconWrapper
        :style="{ backgroundColor }"
    >
        <v-icon
            icon="PolicyIconBlockOnlineMusicAndVideo"
            :color="iconColor"
            size="24"
        />
    </IconWrapper>
</template>
